/**
 * TAX-FULFILLMENT-CONTACT-DELINQUENT-PREMIUM-UI-001 — compact info tile.
 * Read mode: value or "—". Edit mode (children): the caller's input is rendered inside the same frame,
 * so permissions / commit logic stay exactly where they were.
 */
import React from 'react';
import { ExternalLink } from 'lucide-react';
import { CopyIconButton } from '../ui/copy-field';

export const ContactTile = ({ icon: Icon, label, value, tone = 'tcp-tile-blue', editable = false, link = false, copy = false, testId, className = '', children }) => {
  const v = (value ?? '').toString().trim();
  const href = link && v ? (v.startsWith('http') ? v : `https://${v}`) : null;
  return (
    <div className={`tcp-info-tile ${className}`} data-testid={testId}>
      <span className={`tcp-tile ${tone}`} style={{ width: 30, height: 30 }}><Icon className="w-4 h-4" /></span>
      <div className="min-w-0 flex-1">
        <div className="text-[11px] font-medium text-slate-500">{label}</div>
        {editable ? (
          <div className="mt-0.5">{children}</div>
        ) : (
          <div className="flex items-start gap-1.5">
            <div className={`tcp-info-value tcp-fade-in ${v ? '' : 'is-empty'}`} data-testid={testId ? `${testId}-value` : undefined} key={v}>
              {v || '—'}
            </div>
            {v && href && (
              <a href={href} target="_blank" rel="noopener noreferrer" className="mt-0.5 text-slate-400 hover:text-blue-600 tcp-anim" title="Open" data-testid={testId ? `${testId}-open` : undefined}>
                <ExternalLink className="w-3.5 h-3.5" />
              </a>
            )}
            {v && copy && <CopyIconButton value={v} label={label} size="sm" />}
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactTile;
